import { snakeCase, text, timestamp, unique } from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { approvalStatusTable } from './approval-status.table'
import { benefitsTable } from './benefits.table'
import { clientsTable } from './clients.table'
import { usersTable } from './users.table'

export const benefitApplicationsTable = snakeCase.table(
    'benefit_applications',
    {
        id: id('bap'),
        benefitId: text()
            .notNull()
            .references(() => benefitsTable.id, {
                onDelete: 'cascade',
                onUpdate: 'cascade',
            }),
        employeeId: text().references(() => usersTable.id, {
            onDelete: 'set null',
            onUpdate: 'cascade',
        }),
        clientId: text().references(() => clientsTable.id, {
            onDelete: 'cascade',
            onUpdate: 'cascade',
        }),
        statusId: text()
            .notNull()
            .references(() => approvalStatusTable.id, {
                onDelete: 'restrict',
                onUpdate: 'cascade',
            }),
        requestedAt: timestamp({
            withTimezone: true,
        }).defaultNow(),
        allocatedAt: timestamp({ withTimezone: true }),
        cancelledAt: timestamp({ withTimezone: true }),
        notes: text(),
        ...timestamps,
    },
    (table) => [
        unique('benefit_application_unique').on(
            table.benefitId,
            table.employeeId,
        ),
    ],
)
